import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { DecimalPipe } from './decimal.pipe';

@NgModule({
  declarations:[FilterPipe, SearchPipe, ShortNamePipe, DecimalPipe],
  imports:[CommonModule],
  exports:[FilterPipe, SearchPipe, ShortNamePipe, DecimalPipe]
})

export class PipeModule{}
